import { Component, type ReactNode } from 'react';

import classNames from 'classnames';

import { nameInitials } from '@iconik-io/core/src/name_initials';
import { Text } from '@iconik-io/uad';

import IconButton from '../../../ui/icon_button/icon_button';
import type {
  SelectOption,
  ValueComponentProps,
} from '../../../ui/select_field/types';

import styles from './select_field_username_value.module.css';

export type UserNameOption = SelectOption & {
  photo?: string;
  email?: string;
};
type Props = ValueComponentProps<UserNameOption>;

type State = {
  loaded?: boolean;
  loadingFinished?: boolean;
};
class UserNameValue extends Component<Props> {
  handleDeleteClick = (): void => {
    const { onDelete, value } = this.props;
    onDelete?.(value);
  };
  state: State = {};

  onLoad = (): void => {
    this.setState({ loaded: true, loadingFinished: true });
  };

  render(): ReactNode {
    const { value, isDisabled } = this.props;
    const name = value.label.split(' ');
    const userInitials = nameInitials({
      first_name: name[0],
      last_name: name[1],
    });
    const imageLoaded = Boolean(this.state.loaded && value.photo);

    return (
      <div
        className={isDisabled ? styles.root_disabled : styles.root}
        role="listitem"
      >
        <img
          aria-label="User photo"
          src={value.photo}
          alt=""
          className={classNames(styles.image, {
            [styles.image_hidden]: !this.state.loaded,
          })}
          onLoad={this.onLoad}
        />

        {!imageLoaded ? (
          <div aria-label="User initials" className={styles.initials}>
            <Text color="inherit" variant="value_s">
              {userInitials.toUpperCase()}
            </Text>
          </div>
        ) : null}
        <div aria-label="User name" className={styles.label}>
          {value.label}
        </div>
        <IconButton
          aria-label="Delete"
          className={styles.delete}
          iconName="deletion_erase"
          onClick={this.handleDeleteClick}
          disabled={isDisabled}
        />
      </div>
    );
  }
}

export default UserNameValue;
